import React from "react";
import cx from "classnames";
import dayjs from "dayjs";
import styles from "./Banner.module.scss";

export interface BannerProps {
  formattedPhone: string;
}

declare let portalbannerSettings: string;

export const PortalBanner = () => {
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  const bsetting = portalbannerSettings
    ? portalbannerSettings.split("~")
    : null;
  if (bsetting === null) return null;

  const showBanner =
    bsetting.length > 0 &&
    bsetting[0] === "publish" &&
    dayjs(bsetting[2]).add(1, "day").isAfter(dayjs());
  React.useEffect(() => {
    if (!containerRef.current) return;
    const links = containerRef.current.querySelectorAll<HTMLAnchorElement>("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noreferrer");
    });
  }, [bsetting?.[3]]);
  if (showBanner) {
    return (
      <div
        className={cx(styles.banner, styles[bsetting[1]])}
        ref={containerRef}
        dangerouslySetInnerHTML={{
          __html: bsetting[3].replace(/&lt;/g, "<").replace(/&gt;/g, ">"),
        }}
      />
    );
  } else {
    return null;
  }
};
